import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, Switch } from 'react-router-dom'
import { unregister } from './registerServiceWorker'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import { MuiThemeProvider } from '@material-ui/core/styles'
import thunk from 'redux-thunk'
import { SwxThemeProvider } from 'swx-atomic-component-lib'

import 'inter-ui'
import './styles/index.css'
import history from './helpers/history'
import App from './App'
import reducers from './reducers'
import logoutMiddleware from './middlewares/logout.middleware'
import theme from './helpers/theme.helper'
import Logout from './components/Logout.component'
import Login from './components/Login.component'
import Register from './components/registerNew'
import SwitchAccount from './components/SwitchAccount.component'
import SetPassword from './components/SetPassword.component'
import ForgotPassword from './components/ForgotPassword.component'
import ErrorPage from './components/Error.component'
import AppDownPage from './components/appdown'
import EmbeddedRegister from './components/embeddedRegister'

const store = createStore(reducers, applyMiddleware(thunk, promiseMiddleware(), logoutMiddleware))

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <SwxThemeProvider>
        <Router history={history}>
          <>
            <Switch>
              <Route path='/error' component={ErrorPage} />
              <Route path='/app-down' component={AppDownPage} />
              <Route path='/logout' component={Logout} />
              <Route path='/login' component={Login} />
              <Route path='/register' component={Register} />
              <Route path='/embeddedregister' component={EmbeddedRegister} />
              <Route path='/switch' component={SwitchAccount} />
              <Route path='/forgot' component={ForgotPassword} />
              <Route path='/verify/:token' component={SetPassword} />
              <Route path='/password/update' component={props => <SetPassword {...props} forceUpdate />} />
              <Route path='/' component={App} />
            </Switch>
          </>
        </Router>
      </SwxThemeProvider>
    </MuiThemeProvider>
  </Provider>
  , document.getElementById('root'))
unregister()
